import React from 'react';
import Markdown from 'react-remarkable';

const content = `
# Stand on the shoulders of giants

We offer free, in-depth guides on how to achieve some of the most ambitious and life-changing goals.

But for most people, this isn't enough. **That's why we offer a paid program, where you'll be assisted by people and software to complete any of our goals**. Our track record is extremely good, and much better than competitors. For example, 75% of users who work with us on the goal of finding a partner, find a partner within a year who they report being extremely satisfied with.

## Here's how it works:

### Onboarding and orientation (free)

Getting started is easy. We begin with a brief **self-assessment survey**, to help us learn more about where you're currently at with this goal. We'll follow up this survey, with a **15 minute phone call with one of our experts**. We'll continue learning more about you, and your motivations for achieving this goal. This helps us create an **iron-clad, personalized plan** for making progress.

### Checking in

Now that you've worked with one of our experts to create a plan, you'll continue **checking in weekly** with them, to discuss what's going well and what you could use additional help with. Goal achievement is a hairy process, one that our experts understand well and are eager to assist you with.

### Tracking your progress

You'll also be introduced to our software suite. We leverage software and technology to help you **observe progress at the most granular levels** possible for your goal. In English, this means you'll see your progress in days or weeks, versus months or years. This lets can tap into your natural, intrinsic motivation for your goal.

### 24/7 concierge service

Our experts are **available 24/7** to help you out. If anything comes up, big or small that you'd like to discuss, we're here to help.
`;

export default function OurProcess() {
  return (
    <div className="mw7">
      <Markdown>{content}</Markdown>
      <div className="tc">
        <button to="/our-process" className="f6 link dim ph3 pv2 mb2 dib white bg-black w-75 tc">
          Get started <span className="">(coming soon)</span>
        </button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/our-process.js